import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22custom-fonts.ts%22,%22import%22:%22Merriweather%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22display%22:%22swap%22,%22weight%22:[%22300%22],%22variable%22:%22--custom-font-merriweather%22,%22preload%22:false}],%22variableName%22:%22merriweather%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Merriweather', 'Merriweather Fallback'",
        fontWeight: 300,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
